import { Suspense, lazy } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Panel } from 'foundations-components/transitional/components/Panel';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import { Text } from 'foundations-components/components/Text';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import PanelOverlay from 'personalization-lib/components/shared/display/PanelOverlay';
import withModalErrorHandling from 'personalization-lib/components/shared/hocs/withModalErrorHandling';
import useOnNavigation from 'personalization-lib/hooks/nav/useOnNavigation';
import { CREATE_MODES } from 'personalization-lib/constants/variantCreation';
import { showOpenPanelErrorAlert } from 'personalization-lib/utils/alerts';
import { getVariantsEditorUrl } from 'personalization-lib/utils/urls';
import { redirectToPage } from 'personalization-lib/utils/location';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CreateVariantPanelContent = /*#__PURE__*/lazy(() => import('./CreateVariantPanelContent'));
const CreateVariantPanel = ({
  showOverlay,
  mode,
  onClose,
  onCreateSuccess = strategyId => redirectToPage(getVariantsEditorUrl(strategyId)),
  onCreateError,
  initialData
}) => {
  useOnNavigation(onClose);
  return /*#__PURE__*/_jsx(PanelOverlay, {
    hasOverlay: showOverlay,
    children: /*#__PURE__*/_jsxs(Panel, {
      width: 700,
      "data-test-id": "create-variant-panel",
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose,
        "data-test-id": "create-variant-panel-close-button"
      }), /*#__PURE__*/_jsx(PanelHeader, {
        children: /*#__PURE__*/_jsx(Text, {
          as: "h2",
          children: mode === CREATE_MODES.MANUAL ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "personalizationLib.createVariantPanel.title.manual"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "personalizationLib.createVariantPanel.title.ai"
          })
        })
      }), /*#__PURE__*/_jsx(Suspense, {
        fallback: /*#__PURE__*/_jsx(LoadingSpinner, {
          grow: true
        }),
        children: /*#__PURE__*/_jsx(CreateVariantPanelContent, {
          mode: mode,
          onClose: onClose,
          onCreateSuccess: onCreateSuccess,
          onCreateError: onCreateError,
          initialData: initialData
        })
      })]
    })
  });
};
export default withModalErrorHandling(CreateVariantPanel, {
  onComponentError: showOpenPanelErrorAlert
});